import React, {Component} from 'react'

import OneLineEditor from '../../../components/OneLineEditor'
import KingakuEditor from '../../../components/KingakuEditor'
import EstimationStore from '../../../libs/EstimationStore'
import EstimationActions from '../../../libs/EstimationActions'
import Utils from '../../../libs/Utils'

class EstimationSheetTab extends Component {
  constructor (props) {
    super(props)
    if (this.props.estimationId) {
      EstimationStore.setData({
        currentEstimationId: this.props.estimationId
      })
    }
    this.state = {
      data: EstimationActions.getCurrentEstimation(),
      isEditable: this.props.isEditable,
      isPrintable: this.props.isPrintable,
      listener: null
    }
  }
  componentDidMount () {
    this.setState({
      listener: EstimationStore.addListener('change', () => {
        this.setState({
          data: EstimationActions.getCurrentEstimation()
        })
      })
    })
  }
  componentWillUnmount () {
    if (this.state.listener) this.state.listener.remove()
  }
  getSummary (kingakuGoukei, materialUnitPrice, katawakuSuuryou,
    katawakuUnpanhi, anzenKanriHiRitsu, ippanKanriHiRitsu, nebiki, tax, koyounushiRyouritsu, kanyuuritsu
  ) {
    const sumA = kingakuGoukei
    const sumB = Number(materialUnitPrice).toFixed(0) * katawakuSuuryou
    const sumC = katawakuUnpanhi * katawakuSuuryou
    const sumD = Math.round((sumA + sumB + sumC) * (anzenKanriHiRitsu || 0) / 100)
    const sumE = Math.round((sumA + sumB + sumC) * (ippanKanriHiRitsu || 0) / 100)
    const sumF = nebiki
    
    // 施工費（税抜）を計算（sumTaxの計算に使用されている金額）
    const sumSekoushiZeinuki = (sumA + sumB + sumC + sumD + sumE - sumF)
    
    // sumTaxの計算をsumSekoushiZeinukiを用いてより明確に
    const sumTax = Math.round(sumSekoushiZeinuki * tax / 100)
    const sumSekoushiGoukei = sumSekoushiZeinuki + sumTax

    const sumHukurihiMax = koyounushiRyouritsu * sumA
    const sumHukurihiKanyuubun = Math.round(sumHukurihiMax * kanyuuritsu / 100)
    
    // 法定福利費の消費税を計算
    const sumHukurihiTax = Math.round(sumHukurihiKanyuubun * tax / 100)
    
    const sumHukurihiGoukei = sumHukurihiKanyuubun + sumHukurihiTax
    
    return {
      sumA, sumB, sumC, sumD, sumE, sumF, sumTax, 
      sumSekoushiZeinuki, // 施工費（税抜）を追加
      sumSekoushiGoukei, 
      sumHukurihiMax, 
      sumHukurihiKanyuubun, // 法定福利費（税抜）
      sumHukurihiTax, // 法定福利費の消費税を追加
      sumHukurihiGoukei
    }
  }
  render () {
    const sharedValues = EstimationActions.getEstimationSharedValues()
    const materialUnitPrice = sharedValues.materialUnitPrice
    const katawakuSuuryou = sharedValues.katawakuSuuryou
    var uchiwakeList = []
    var uchiwakeLines = []
    const data = this.state.data.uchiwakeList
    // 名称・仕様・備考の文字数からセル内で折り返される行数を概算する。
    // 列幅: 名称 56mm / 仕様 56mm(colspan2) / 備考 ≒ 60mm。13px日本語1文字 ≒ 3.4mm。
    // 1行あたりの収容文字数を控えめに見積もって安全側に倒す。
    const estimateUchiwakeLines = (item) => {
      const NAME_CHARS_PER_LINE = 12
      const SPEC_CHARS_PER_LINE = 14
      const NOTE_CHARS_PER_LINE = 20
      const nameLen = (item.name || '').length
      const specLen = (item.specification || '').length
      const noteLen = (item.note || '').length
      const nameLines = Math.max(1, Math.ceil(nameLen / NAME_CHARS_PER_LINE))
      const specLines = Math.max(1, Math.ceil(specLen / SPEC_CHARS_PER_LINE))
      const noteLines = Math.max(1, Math.ceil(noteLen / NOTE_CHARS_PER_LINE))
      return Math.max(nameLines, specLines, noteLines, 1)
    }
    const daikuLabor = EstimationActions.getLaborSharedValues('daiku')
    const daikuLaborUnitPrice = daikuLabor.laborUnitPrice
    const koyounushiRyouritsu = daikuLabor.koyounushiRyouritsu
    const kaitaiLabor = EstimationActions.getLaborSharedValues('kaitai')
    const kaitaiLaborUnitPrice = kaitaiLabor.laborUnitPrice
    let kingakuGoukei = 0
    let primeContractorKingakuGoukei = 0
    const inputStyle = {
      backgroundColor: this.state.isEditable ? '#ffffe0' : 'FFFFFF',
      cursor: this.state.isEditable ? 'pointer' : 'normal'
    }
    const primeContractorInputStyle = {display: this.state.data.primeContractorInputMode ? 'table-cell' : 'none'}
    let primeContractorEditableInputStyle = {}
    primeContractorEditableInputStyle = Object.assign(primeContractorEditableInputStyle, inputStyle)
    primeContractorEditableInputStyle = Object.assign(primeContractorEditableInputStyle, primeContractorInputStyle)

    for (let i = 0; i < data.length; i++) {
      const kingaku = Number((daikuLaborUnitPrice * data[i].daikuNinku + kaitaiLaborUnitPrice * data[i].kaitaiNinku) / data[i].suuryou).toFixed(0) * data[i].suuryou
      const primeContractorKingaku = data[i].primeContractorUnitPrice * data[i].suuryou
      kingakuGoukei += isNaN(kingaku) ? 0 : kingaku

      primeContractorKingakuGoukei += isNaN(primeContractorKingaku) ? 0 : primeContractorKingaku

      uchiwakeList.push(
        <tr key={i}>
          <td className='kw-pad3'>{data[i].name}</td>
          <td className='' colSpan='2'>{data[i].specification}</td>
          <td className='text-center'>{data[i].tani}</td>
          <td className='text-right'>{Utils.convSuuryou(data[i].suuryou)}</td>
          <td className='text-right'>{Utils.convKingaku((daikuLaborUnitPrice * data[i].daikuNinku + kaitaiLaborUnitPrice * data[i].kaitaiNinku) / data[i].suuryou)}</td>
          <td className='text-right'>{Utils.convKingaku(Number((daikuLaborUnitPrice * data[i].daikuNinku + kaitaiLaborUnitPrice * data[i].kaitaiNinku) / data[i].suuryou).toFixed(0) * data[i].suuryou)}</td>
          <td className='text-right' style={primeContractorEditableInputStyle}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='primeContractorUnitPrice' isCommaSeparated prefix='¥' isNum textAlign='right' /></td>
          <td className='text-right' style={primeContractorInputStyle}>{Utils.convKingaku(data[i].primeContractorUnitPrice * data[i].suuryou, 0, true)}</td>
          <td style={inputStyle}><OneLineEditor isList listName='uchiwakeList' index={i} bindingDataAttribute='note' /></td>
        </tr>
      )
      uchiwakeLines.push(estimateUchiwakeLines(data[i]))
    }
    const sum = this.getSummary(kingakuGoukei, materialUnitPrice, katawakuSuuryou,
      this.state.data.estimationBodyKatawakuUnpanhi,
      this.state.data.estimationBodyAnzenKanriHiRitsu,
      this.state.data.estimationBodyIppanKanriHiRitsu,
      this.state.data.estimationBodyNebiki,
      this.state.data.estimationConfigTax,
      koyounushiRyouritsu,
      this.state.data.estimationBodyKanyuuritsu
    )
    const sumP = this.getSummary(primeContractorKingakuGoukei, this.state.data.estimationBodyPrimeContractorMaterialCost, katawakuSuuryou,
      this.state.data.estimationBodyPrimeContractorKatawakuUnpanhi,
      this.state.data.estimationBodyAnzenKanriHiRitsu,
      this.state.data.estimationBodyIppanKanriHiRitsu,
      this.state.data.estimationBodyPrimeContractorNebiki,
      this.state.data.estimationConfigTax,
      koyounushiRyouritsu,
      this.state.data.estimationBodyKanyuuritsu
    )
    // --- 【消費税表示設定】に基づく表示切り替えロジックを追加 ---
    const displayTaxType = this.state.data.estimationConfigDisplayTax // 'Zeinuki' or 'Zeikomi'

    // 表示する施工費の金額を決定
    const sekoushiDisplayAmount = displayTaxType === 'Zeinuki' 
      ? sum.sumSekoushiZeinuki 
      : sum.sumSekoushiGoukei

    // 表示する法定福利費の金額を決定
    const hukurihiDisplayAmount = displayTaxType === 'Zeinuki' 
      ? sum.sumHukurihiKanyuubun 
      : sum.sumHukurihiGoukei

    // 表示する合計金額を決定
    const totalDisplayAmount = displayTaxType === 'Zeinuki' 
      ? (sum.sumSekoushiZeinuki + sum.sumHukurihiKanyuubun) 
      : (sum.sumSekoushiGoukei + sum.sumHukurihiGoukei)

    // 表示する税区分文字列を決定
    const taxStatus = displayTaxType === 'Zeinuki' ? '(税抜)' : '(税込)'

    // ページ毎のtrを作成
    const pages = []
    const sumATr = [
      (<tr key='sumATr'>
        <td />
        <td colSpan='2'>計(a)</td>
        <td className='text-center'>㎡</td>
        <td className='text-right'>{Utils.convSuuryou(katawakuSuuryou)}</td>
        <td className='text-right'>{Utils.convKingaku(sum.sumA / katawakuSuuryou)}</td>
        <td className='text-right'>{Utils.convKingaku(sum.sumA)}</td>
        <td className='text-right' style={primeContractorInputStyle}>{Utils.convKingaku(sumP.sumA / katawakuSuuryou, 0, true)}</td>
        <td className='text-right' style={primeContractorInputStyle}>{Utils.convKingaku(sumP.sumA, 0, true)}</td>
        <td />
      </tr>)
    ]
    const materialCostTr = [
      (<tr key='materialCostTr'>
        <td>b.材料費</td>
        <td colSpan='2' />
        <td className='text-center'>㎡</td>
        <td className='text-right'>{Utils.convSuuryou(katawakuSuuryou)}</td>
        <td className='text-right'>{Utils.convKingaku(materialUnitPrice)}</td>
        <td className='text-right'>{Utils.convKingaku(sum.sumB)}</td>
        <td className='text-right' style={primeContractorEditableInputStyle}><KingakuEditor bindingDataAttribute='estimationBodyPrimeContractorMaterialCost' /></td>
        <td className='text-right' style={primeContractorEditableInputStyle}>
          {Utils.convKingaku(sumP.sumB, 0, true)}
        </td>
        <td />
      </tr>)
    ]
    const UnpanshiTr = [
      (<tr key='UnpanshiTr'>
        <td>c.型枠運搬費</td>
        <td colSpan='2' />
        <td className='text-center'>㎡</td>
        <td className='text-right'>{Utils.convSuuryou(katawakuSuuryou)}</td>
        <td className='text-right' style={inputStyle}><KingakuEditor bindingDataAttribute='estimationBodyKatawakuUnpanhi' /></td>
        <td className='text-right'>{Utils.convKingaku(sum.sumC)}</td>
        <td className='text-right' style={primeContractorEditableInputStyle}><KingakuEditor bindingDataAttribute='estimationBodyPrimeContractorKatawakuUnpanhi' /></td>
        <td className='text-right' style={primeContractorEditableInputStyle}>{Utils.convKingaku(sumP.sumC, 0, true)}</td>
        <td />
      </tr>)
    ]
    const sumABCTr = (
      <tr key='sumABCTr'>
        <td />
        <td colSpan='2'>計 (a+b+c)</td>
        <td className='text-center'>㎡</td>
        <td className='text-right'>{Utils.convSuuryou(katawakuSuuryou)}</td>
        <td className='text-right'>{Utils.convKingaku((sum.sumA + sum.sumB + sum.sumC) / katawakuSuuryou)}</td>
        <td className='text-right'>{Utils.convKingaku(sum.sumA + sum.sumB + sum.sumC)}</td>
        <td className='text-right' style={primeContractorInputStyle}>
          {Utils.convKingaku((sumP.sumA + sumP.sumB + sumP.sumC) / katawakuSuuryou, 0, true)}</td>
        <td className='text-right' style={primeContractorInputStyle}>{Utils.convKingaku(sumP.sumA + sumP.sumB + sumP.sumC, 0, true)}</td>
        <td />
      </tr>
    )
    const anzenKanriHiTr = (
      <tr key='anzenKanriHiTr'>
        <td>d.安全管理費</td>
        {this.state.isPrintable ? <td>(a+b+c) ✕ ① = d</td>:<td>(a+b+c) ✕ ◯% = d</td>}
        {this.state.isPrintable ?
          <td style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>①</span>
            <span>
              {this.state.data.estimationBodyAnzenKanriHiRitsu !== undefined &&
               this.state.data.estimationBodyAnzenKanriHiRitsu !== null &&
               this.state.data.estimationBodyAnzenKanriHiRitsu !== '' ?
              `${parseFloat(this.state.data.estimationBodyAnzenKanriHiRitsu).toFixed(1)}%`:''}
            </span>
          </td>:
          <td className='text-right' style={inputStyle}><OneLineEditor bindingDataAttribute='estimationBodyAnzenKanriHiRitsu' decimalPlaces='1' suffix='%' isNum textAlign='right' /></td>}
        <td className='text-center'>㎡</td>
        <td className='text-right'>{Utils.convSuuryou(katawakuSuuryou)}</td>
        <td className='text-right'>{Utils.convKingaku(sum.sumD / katawakuSuuryou)}</td>
        <td className='text-right'>{Utils.convKingaku(sum.sumD)}</td>
        <td style={primeContractorInputStyle} />
        <td style={primeContractorInputStyle} />
        {this.state.isPrintable ? <td />:<td>◯は各社設定％を記入</td>}
      </tr>
    )
    function getBlankTr () {
      return (
        <tr key={Utils.uuid() + 'blankTr'}>
          <td>&nbsp;</td>
          <td colSpan='2' />
          <td />
          <td />
          <td />
          <td />
          <td style={primeContractorInputStyle} />
          <td style={primeContractorInputStyle} />
          <td />
        </tr>
      )
    }
    const ippanKanriHiTr = (
      <tr key='ippanKanriHiTr'>
        <td>e.一般管理費</td>
        {this.state.isPrintable ? <td>(a+b+c) ✕ ② = e</td>:<td>(a+b+c) ✕ ◯% = e</td>}
        {this.state.isPrintable ?
          <td style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>②</span>
            <span>
              {this.state.data.estimationBodyIppanKanriHiRitsu !== undefined &&
               this.state.data.estimationBodyIppanKanriHiRitsu !== null &&
               this.state.data.estimationBodyIppanKanriHiRitsu !== '' ?
              `${parseFloat(this.state.data.estimationBodyIppanKanriHiRitsu).toFixed(1)}%`:''}
            </span>
          </td>:
          <td className='text-right' style={inputStyle}><OneLineEditor bindingDataAttribute='estimationBodyIppanKanriHiRitsu' decimalPlaces='1' suffix='%' isNum textAlign='right' /></td>}
        <td className='text-center'>㎡</td>
        <td className='text-right'>{Utils.convSuuryou(katawakuSuuryou)}</td>
        <td className='text-right'>{Utils.convKingaku(sum.sumE / katawakuSuuryou)}</td>
        <td className='text-right'>{Utils.convKingaku(sum.sumE)}</td>
        <td style={primeContractorInputStyle} />
        <td style={primeContractorInputStyle} />
        {this.state.isPrintable ? <td />:<td>◯は各社設定％を記入</td>}
      </tr>
    )
    const sumABCDTr = (
      <tr key='sumABCDTr'>
        <td />
        <td colSpan='2'>計 (a+b+c+d+e)</td>
        <td className='text-center'>㎡</td>
        <td className='text-right'>{Utils.convSuuryou(katawakuSuuryou)}</td>
        <td className='text-right'>{Utils.convKingaku((sum.sumA + sum.sumB + sum.sumC + sum.sumD + sum.sumE) / katawakuSuuryou)}</td>
        <td className='text-right'>{Utils.convKingaku(sum.sumA + sum.sumB + sum.sumC + sum.sumD + sum.sumE)}</td>
        <td className='text-right' style={primeContractorInputStyle}>{Utils.convKingaku((sumP.sumA + sumP.sumB + sumP.sumC + sumP.sumD + sumP.sumE) / katawakuSuuryou, 0, true)}</td>
        <td className='text-right' style={primeContractorInputStyle}>{Utils.convKingaku(sumP.sumA + sumP.sumB + sumP.sumC + sumP.sumD + sumP.sumE, 0, true)}</td>
        <td />
      </tr>
    )

    const nebikiTr = (
      <tr key='nebikiTr'>
        <td />
        <td colSpan='2'>f.出精値引き</td>
        <td />
        <td />
        <td />
        <td className='text-right' style={inputStyle}><KingakuEditor bindingDataAttribute='estimationBodyNebiki' /></td>
        <td style={primeContractorInputStyle} />
        <td className='text-right' style={primeContractorEditableInputStyle}><KingakuEditor bindingDataAttribute='estimationBodyPrimeContractorNebiki' /></td>
        <td />
      </tr>
    )

    const sumABCDminusE = (
      <tr key='sumABCDminusE'>
        <td />
        <td colSpan='2'>計 (a+b+c+d+e-f)</td>
        <td className='text-center'>㎡</td>
        <td className='text-right'>{Utils.convSuuryou(katawakuSuuryou)}</td>
        <td className='text-right'>{Utils.convKingaku((sum.sumA + sum.sumB + sum.sumC + sum.sumD + sum.sumE - sum.sumF) / katawakuSuuryou)}</td>
        <td className='text-right'>{Utils.convKingaku(sum.sumA + sum.sumB + sum.sumC + sum.sumD + sum.sumE - sum.sumF)}</td>
        <td style={primeContractorInputStyle} />
        <td style={primeContractorInputStyle} />
        <td />
      </tr>
    )

    const sekouhiTax = (
      <tr key='sekouhiTax'>
        <td />
        <td>消 費 税</td>
        <td className='text-right'>{this.state.data.estimationConfigTax}%</td>
        <td />
        <td />
        <td />
        <td className='text-right'>{Utils.convKingaku(sum.sumTax)}</td>
        <td style={primeContractorInputStyle} />
        <td className='text-right' style={primeContractorInputStyle}>{Utils.convKingaku(sumP.sumTax, 0, true)}</td>
        <td />
      </tr>
    )

    const sekkeihiKeiTr = (
      <tr key='sekkeihiKeiTr'>
        <td />
        <td colSpan='2'>A. 施工費計</td>
        <td />
        <td />
        <td />
        <td className='text-right'>{Utils.convKingaku(sum.sumSekoushiGoukei)}</td>
        <td style={primeContractorInputStyle} />
        <td className='text-right' style={primeContractorInputStyle}>{Utils.convKingaku(sumP.sumSekoushiGoukei, 0, true)}</td>
        <td />
      </tr>
    )

    const koyounushiHutanritsuTr = (
      <tr key='koyounushiHutanritsuTr'>
        <td>法定福利費</td>
        <td>※雇用主負担率</td>
        <td className='text-right'>{Utils.convSuuryou(koyounushiRyouritsu * 100, 3)}%</td>
        <td className='text-center'>㎡</td>
        <td className='text-right'>{Utils.convSuuryou(katawakuSuuryou)}</td>
        <td className='text-right'>{Utils.convKingaku(sum.sumHukurihiMax / katawakuSuuryou)}</td>
        <td className='text-right'>{Utils.convKingaku(sum.sumHukurihiMax)}</td>
        <td className='text-right' style={primeContractorInputStyle}>{Utils.convKingaku(sumP.sumHukurihiMax / katawakuSuuryou, 0, true)}</td>
        <td className='text-right' style={primeContractorInputStyle}>{Utils.convKingaku(sumP.sumHukurihiMax, 0, true)}</td>
        <td />
      </tr>
    )

    const kanyuuritsuTr = (
      <tr key='kanyuuritsuTr'>
        <td />
        <td>※当工事従事者加入率</td>
        <td className='text-right'>{this.state.data.estimationBodyKanyuuritsu}%</td>
        <td />
        <td />
        <td />
        <td className='text-right'>{Utils.convKingaku(sum.sumHukurihiKanyuubun)}</td>
        <td className='text-center' style={primeContractorInputStyle} />
        <td className='text-right' style={primeContractorInputStyle}>{Utils.convKingaku(sumP.sumHukurihiKanyuubun, 0, true)}</td>
        <td />
      </tr>
    )

    const hukuriHiTaxTr = (
      <tr key='hukuriHiTaxTr'>
        <td />
        <td>消費税</td>
        <td className='text-right'>{this.state.data.estimationConfigTax}%</td>
        <td />
        <td />
        <td />
        <td className='text-right'>{Utils.convKingaku(sum.sumHukurihiKanyuubun * this.state.data.estimationConfigTax / 100)}</td>
        <td style={primeContractorInputStyle} />
        <td className='text-right' style={primeContractorInputStyle}>{Utils.convKingaku(sumP.sumHukurihiKanyuubun * this.state.data.estimationConfigTax / 100, 0, true)}</td>
        <td />
      </tr>
    )

    const hukuriKeiTr = (
      <tr key='hukuriKeiTr'>
        <td />
        <td colSpan='2'>B. 法定福利費計</td>
        <td />
        <td />
        <td />
        <td className='text-right'>{Utils.convKingaku(sum.sumHukurihiGoukei)}</td>
        <td style={primeContractorInputStyle} />
        <td className='text-right' style={primeContractorInputStyle}>{Utils.convKingaku(sumP.sumHukurihiGoukei, 0, true)}</td>
        <td />
      </tr>
    )

    const goukeiTr = (
      <tr key='goukeiTr'>
        <td />
        <td colSpan='2'>合計 (A+B)</td>
        <td />
        <td />
        <td />
        <td className='text-right'>{Utils.convKingaku(sum.sumSekoushiGoukei + sum.sumHukurihiGoukei)}</td>
        <td style={primeContractorInputStyle} />
        <td className='text-right' style={primeContractorInputStyle}>{Utils.convKingaku(sumP.sumSekoushiGoukei + sumP.sumHukurihiGoukei, 0, true)}</td>
        <td />
      </tr>
    )

    const firstPageTr = []
    // 行数(セル内の折返し含む)を予算とする。trListの各要素は1行扱い。
    const firstPageLineBudget = 12
    const pageLineBudget = 25
    let firstPageLines = 0
    const trList = [
      sumATr,
      materialCostTr,
      UnpanshiTr,
      sumABCTr,
      anzenKanriHiTr,
      ippanKanriHiTr,
      sumABCDTr,
      nebikiTr,
      sumABCDminusE,
      sekouhiTax,
      getBlankTr(), // keyを重複させないため
      sekkeihiKeiTr,
      getBlankTr(),
      koyounushiHutanritsuTr,
      kanyuuritsuTr,
      hukuriHiTaxTr,
      hukuriKeiTr,
      getBlankTr(),
      goukeiTr
    ]
    // 最初のページは特別処理
    while (uchiwakeList.length > 0) {
      const lines = uchiwakeLines[0]
      if (firstPageTr.length > 0 && firstPageLines + lines > firstPageLineBudget) break
      firstPageTr.push(uchiwakeList.shift())
      uchiwakeLines.shift()
      firstPageLines += lines
    }
    // 内訳項目が残っている場合は集計行(計(a)等)をこのページに入れない
    if (uchiwakeList.length === 0) {
      while (firstPageLines < firstPageLineBudget && trList.length > 0) {
        firstPageTr.push(trList.shift())
        firstPageLines++
      }
    }
    const firstPage = (
      <section key='firstPage' className='kw-print-page'>
        <div className='kw-container'>
          <div className='kw-destination kw-destination-title'>御見積書</div>{/* <!-- .kw-destination --> */}
          <div className='kw-destination'>
            <table>
              <thead>
                <tr>
                  <th className='kw-company-name' />
                  <th className='kw-honorific' />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th className='kw-bold text-center kw-text-big2' style={inputStyle}>
                    <OneLineEditor bindingDataAttribute='estiamtionprimeContractor' />
                  </th>
                  <th className='kw-bold text-center kw-text-big2'>御中</th>
                </tr>
              </tbody>
            </table>
          </div>{/* <!-- .kw-destination --> */}
          <div className='kw-overview-left'>
            <p className='kw-pad10'>下記の通りお見積申し上げます。</p>
            <table>
              <thead>
                <tr>
                  <th className='kw-item' />
                  <th className='kw-text' />
                  <th className='kw-yen' />
                  <th className='tax' />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th className='kw-pad3'>工事名称</th>
                  <td colSpan='3' style={inputStyle}>
                    <OneLineEditor bindingDataAttribute='estimationTitle' />
                  </td>
                </tr>
                <tr>
                  <th className='kw-pad3'>施工費</th>
                  <td className='kw-text-big3 kw-yen' colSpan='2'>{Utils.convKingaku(sekoushiDisplayAmount)}</td>
                  <td>{taxStatus}</td>
                </tr>
                <tr>
                  <th className='kw-pad3'>法定福利費</th>
                  <td className='kw-text-big3 kw-yen' colSpan='2'>{Utils.convKingaku(hukurihiDisplayAmount)}</td>
                  <td>{taxStatus}</td>
                </tr>
                <tr>
                  <th className='kw-pad3 kw-bold'>合計</th>
                  <td className='kw-bold kw-text-big3 kw-yen' colSpan='2'>{Utils.convKingaku(totalDisplayAmount)}</td>
                  <td>{taxStatus}</td>
                </tr>
                <tr>
                  <th className='kw-pad3'>施工場所</th>
                  <td colSpan='3' style={inputStyle}>
                    <OneLineEditor bindingDataAttribute='estimationHeaderPlace' />
                  </td>
                </tr>
                <tr>
                  <th className='kw-pad3'>特記事項</th>
                  <td colSpan='3' style={inputStyle}>
                    <OneLineEditor bindingDataAttribute='estimationHeaderNote1' />
                  </td>
                </tr>
                <tr>
                  <th className='kw-pad3' />
                  <td colSpan='3' style={inputStyle}>
                    <OneLineEditor bindingDataAttribute='estimationHeaderNote2' />
                  </td>
                </tr>
                <tr>
                  <td colSpan='4' className='kw-bold'>法定福利費の値引きは不可。</td>
                </tr>
              </tbody>
            </table>
          </div>{/* <!-- .kw-overview-left --> */}
          <div className='kw-overview-right text-left'>
            <div className='kw-right-tbl'>
              <table>
                <thead>
                  <tr>
                    <th className='kw-item' />
                    <th className='kw-text' />
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th className='kw-pad1'>提出期限</th>
                    <td style={inputStyle}><OneLineEditor bindingDataAttribute='estimationHeaderDeadline' /></td>
                  </tr>
                  <tr>
                    <th className='kw-pad1'>納期工期</th>
                    <td style={inputStyle}><OneLineEditor bindingDataAttribute='estimationHeaderDueDate' /></td>
                  </tr>
                  <tr>
                    <th className='kw-pad1'>現場質疑</th>
                    <td style={inputStyle}><OneLineEditor bindingDataAttribute='estimationHeaderShitsugi' /></td>
                  </tr>
                  <tr>
                    <th className='kw-pad1'>工事番号</th>
                    <td style={inputStyle}><OneLineEditor bindingDataAttribute='estimationHeaderKojiNumber' /></td>
                  </tr>
                  <tr>
                    <th className='kw-pad1'>項目番号</th>
                    <td style={inputStyle}><OneLineEditor bindingDataAttribute='estimationHeaderKomokuNumber' /></td>
                  </tr>
                </tbody>
              </table>
              <div className='kw-space3' />
              <table>
                <thead>
                  <tr>
                    <th className='kw-item' />
                    <th className='kw-text' />
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th className='kw-pad1'>業者コード</th>
                    <td style={inputStyle}><OneLineEditor bindingDataAttribute='estimationHeaderGyoshaCode' /></td>
                  </tr>
                </tbody>
              </table>
              <div className='kw-space3' />
            </div>{/* <!-- .kw-right-tbl --> */}
            <div className='overview-contact text-left'>
              <table>
                <thead>
                  <tr>
                    <th className='kw-item' />
                    <th className='kw-text' />
                    <th className='kw-item2' />
                    <th className='kw-text2' />
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th className='kw-pad3'>会社名</th>
                    <td colSpan='3' className='kw-bold kw-text-big-1 kw-pad1t' style={inputStyle}><OneLineEditor bindingDataAttribute='estimationHeaderCompanyName' /></td>
                  </tr>
                  <tr>
                    <th className='kw-pad3'>住所</th>
                    <td colSpan='3' className='kw-text-big-2' style={inputStyle}><OneLineEditor bindingDataAttribute='estimationHeaderCompanyAddress' /></td>
                  </tr>
                  <tr>
                    <th className='kw-pad3'>電話番号</th>
                    <td className='text-center kw-text-big-2' style={inputStyle}><OneLineEditor bindingDataAttribute='estimationHeaderCompanyPhoneNumber' /></td>
                    <th className='kw-pad3'>FAX番号</th>
                    <td className='text-center kw-text-big-2' style={inputStyle}><OneLineEditor bindingDataAttribute='estimationHeaderCompanyFAXNumber' /></td>
                  </tr>
                </tbody>
              </table>
            </div>{/* <!-- .overview-contact --> */}
          </div>{/* <!-- .kw-overview-right --> */}
          <div className='kw-detail'>
            <p className='caution kw-pad10 kw-clear'>図面仕様書契約条項及び現場係員指示によること。</p>
            <table>
              <thead>
                <tr>
                  <th className='kw-name' />
                  <th className='kw-specific' />
                  <th className='kw-specific2' />
                  <th className='kw-unit' />
                  <th className='kw-person' />
                  <th className='kw-person-unit-price' />
                  <th className='kw-yen1' />
                  <th className='kw-yen-unit-price' style={primeContractorInputStyle} />
                  <th className='kw-yen2' style={primeContractorInputStyle} />
                  <th className='kw-note' />
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th className='text-center'>名　　　称</th>
                  <th colSpan='2' className='text-center'>仕　　　様</th>
                  <th className='text-center'>単位</th>
                  <th className='text-center'>員　数</th>
                  <th className='text-center'>単　価</th>
                  <th className='text-center'>金　額</th>
                  <th className='text-center' style={primeContractorInputStyle}>単　価</th>
                  <th className='text-center' style={primeContractorInputStyle}>金　額</th>
                  <th className='text-center'>備　　考</th>
                </tr>
                <tr>
                  <td style={inputStyle}><OneLineEditor bindingDataAttribute='estimationBodyHeadLine1' /></td>
                  <td colSpan='2' style={inputStyle}><OneLineEditor bindingDataAttribute='estimationBodyHeadLine2' /></td>
                  <td />
                  <td />
                  <td />
                  <td />
                  <td style={primeContractorInputStyle} />
                  <td style={primeContractorInputStyle} />
                  <td />
                </tr>
                <tr>
                  <td>a.労務費</td>
                  <td colSpan='2' />
                  <td />
                  <td />
                  <td />
                  <td />
                  <td style={primeContractorInputStyle} />
                  <td style={primeContractorInputStyle} />
                  <td />
                </tr>
                {firstPageTr}
              </tbody>
            </table>
          </div>{/* <!-- .kw-detail --> */}
        </div>{/* <!-- .kw-container --> */}
      </section>
    )

    pages.push(firstPage)
    let pageCount = 0
    function getPage (pageTr) {
      return (
        <section key={(pageCount++)} className='kw-print-page'>
          <div className='kw-container'>
            <div className='kw-detail'>
              <table>
                <thead>
                  <tr>
                    <th className='kw-name' />
                    <th className='kw-specific' />
                    <th className='kw-specific2' />
                    <th className='kw-unit' />
                    <th className='kw-person' />
                    <th className='kw-person-unit-price' />
                    <th className='kw-yen1' />
                    <th className='kw-yen-unit-price' style={primeContractorInputStyle} />
                    <th className='kw-yen2' style={primeContractorInputStyle} />
                    <th className='kw-note' />
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th className='text-center'>名　　　称</th>
                    <th colSpan='2' className='text-center'>仕　　　様</th>
                    <th className='text-center'>単位</th>
                    <th className='text-center'>員　数</th>
                    <th className='text-center'>単　価</th>
                    <th className='text-center'>金　額</th>
                    <th className='text-center' style={primeContractorInputStyle}>単　価</th>
                    <th className='text-center' style={primeContractorInputStyle}>金　額</th>
                    <th className='text-center'>備　　考</th>
                  </tr>
                  {pageTr}
                </tbody>
              </table>
            </div>{/* <!-- .kw-detail --> */}
          </div>{/* <!-- .kw-container --> */}
        </section>
      )
    }
    while (trList.length > 0 || uchiwakeList.length > 0) {
      const pageTr = []
      let pageLines = 0
      while (uchiwakeList.length > 0) {
        const lines = uchiwakeLines[0]
        if (pageTr.length > 0 && pageLines + lines > pageLineBudget) break
        pageTr.push(uchiwakeList.shift())
        uchiwakeLines.shift()
        pageLines += lines
      }
      // 内訳項目が残っている場合は集計行(計(a)等)をこのページに入れない
      if (uchiwakeList.length === 0) {
        while (pageLines < pageLineBudget && trList.length > 0) {
          pageTr.push(trList.shift())
          pageLines++
        }
      }
      pages.push(getPage(pageTr))
    }
    return (
      <div>
        <div style={{width: '307mm', margin: '0 auto'}}>
          <article className='kw-katawaku-art'>
            {pages}
          </article>
        </div>
      </div>
    )
  }
}
EstimationSheetTab.defaultProps = {isEditable: true}
export default EstimationSheetTab



// WEBPACK FOOTER //
// ./src/company_user/pages/secure/EstimationEdit/EstimationSheetTab.js